import React from "react";

export default function TeamMember({ teamMember }) {
  const { name, avatar, id } = teamMember;
  return (
    <div className="checkbox-container">
      <img src={avatar} className="team-avater" alt="" />
      <p className="label">{name}</p>
    </div>
  );
}
